import { render } from "./CaseOpener.vue?vue&type=template&id=415d4e34&scoped=true"
import script from "./CaseOpener.vue?vue&type=script&lang=ts"
export * from "./CaseOpener.vue?vue&type=script&lang=ts"

import "./CaseOpener.vue?vue&type=style&index=0&id=415d4e34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-415d4e34"

export default script